import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { deleteCustomNotificationById } from 'api/auth.api';
import { deleteApplicationGuidelineById } from 'api/auth.api';

export const useApplicationGuidelineDelete = ({ onSuccess } = {}) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteApplicationGuidelineById,

    onSuccess: (res) => {
      queryClient.invalidateQueries(['applicationGuidelineList']);

      onSuccess?.(res);
    },

    onError: (error) => {
      toast({
        title: 'Failed to delete ',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
